import { render, staticRenderFns } from "./CoozzyCaretDownIcon.vue?vue&type=template&id=1b532171&scoped=true"
import script from "./CoozzyCaretDownIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyCaretDownIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyCaretDownIcon.vue?vue&type=style&index=0&id=1b532171&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b532171",
  null
  
)

export default component.exports